import React, { Component } from 'react';
import PaymentPlans from './payment/PaymentPlans';
import FieldLevelHelp from './components/FieldLevelHelp';
import AlertMessage from './AlertMessage';
import PriceView from './components/PriceView';
import withWorkflow from './components/withWorkflow';
import { scrollToMessage } from './util/scrollToMessage';
import RequiredFieldDisclaimer from './components/RequiredFieldDisclaimer';
import UpdatedPaymentRequired from './payment/UpdatedPaymentRequired';
import ExpeditedShippingPayment from './payment/ExpeditedShippingPayment';
import { validateCreditCardForm, validateCreditCardField } from './payment/CreditCardForm';
import InsurancePaymentDisclaimer from './payment/InsurancePaymentDisclaimer';
import BillingFaqLink from './components/BillingFaqLink';
import {getPatientAcknowledgement, getNSAAcknowledgement} from "./util/apiUtils";
import PITLPatientAcknowledgement, { PITLPatientAcknowledgementCheckboxText } from './phsycian-in-the-loop/PITLPatientAcknowledgement';
import {isInternationalOrder, getCustomerCareNumber} from "./util/gearOrderUtil";
// import { PayPalMarks, PayPalScriptProvider } from "@paypal/react-paypal-js";
// import PayPalCheckout, { PayPalButtonWrapper } from './components/paypal/PayPalCheckout';
import {isFullyAccessioned, isUKOrder} from './util/gearOrderUtil';
import ReCAPTCHA from 'react-google-recaptcha';
import AcceptedCreditCards from './payment/AcceptedCreditCards';

class PaymentInfo extends Component {
	constructor(props) {
		super(props);
		const patientRegistration = this.props.userInfo.type === 'prc';
		const physicianInTheLoopOrder = this.props.gearOrder.physicianInTheLoop;
		const ukOrder = isUKOrder(this.props.gearOrder);
		const physicianInTheLoopRecollection = this.props.gearOrder.pitlRecollectionOrderSummary;
		let cardRequired = (this.props.gearOrder.requisitions[0].paymentInfo?.paymentType === 'card') || (physicianInTheLoopOrder && !this.props.gearOrder.dataConfirmed);
		let checkRequired = this.props.gearOrder.requisitions[0].paymentInfo?.paymentType === 'check';
		// Lock payment fields if any non-expedited (or non-resubmittal) payment has been made
		const hasPayment =
			this.props.gearOrder.requisitions?.some(
				(req) =>
					req.paymentInfo &&
					req.paymentInfo.paymentType !== 'expeditedShipping' &&
					req.paymentInfo.paymentType !== 'resubmittal'
			) &&
			(!this.props.gearOrder.pitlRecollectionOrderSummary?.paymentRequired);

		// We don't store discount types so we have to check 'paymentFrom' for affiliate logic
		const hasAffiliateCOde = hasPayment
			&& this.props.gearOrder.requisitions?.some((req) => req.paymentInfo?.paymentFrom === "affiliate");
		let pageLocked = this.props.userInfo.adminUser !== 'true' && (isFullyAccessioned(this.props.gearOrder) || hasPayment);
		let tokenId = physicianInTheLoopRecollection ? '' : this.props.gearOrder.requisitions[0].paymentInfo?.tokenId ?? '';

		let form = {};
		if (this.props.gearOrder.requisitions && this.props.gearOrder.requisitions.length > 0) {
			let paymentType = this.props.gearOrder.requisitions[0].paymentInfo?.paymentType ?? null;
			form.paymentType = { value: paymentType };
			form.checkNo = { value: this.props.gearOrder.requisitions[0].paymentInfo?.checkNo ?? '' };
			form.cardNo = { value: this.props.gearOrder.requisitions[0]?.paymentInfo?.cardNo ?? '' };
			form.cardCvv = { value: this.props.gearOrder.requisitions[0]?.paymentInfo?.cardCvv ?? '' };
			form.cardExpDate = { value: this.props.gearOrder.requisitions[0]?.paymentInfo?.cardExpDate ?? '' };
			form.cardholderName = { value: this.props.gearOrder.requisitions[0]?.paymentInfo?.cardholderName ?? '' };
			form.cardZipCode = { value: this.props.gearOrder.requisitions[0]?.paymentInfo?.cardZipCode ?? '' };
			form.prepay = { value: this.props.gearOrder.requisitions[0]?.paymentInfo?.prcConfirmationNo ?? '' };
			form.installmentIntervalType = {
				value: this.props.gearOrder.requisitions[0].paymentInfo?.installmentIntervalType ?? 'full'
			};
			form.installmentCount = { value: this.props.gearOrder.requisitions[0].paymentInfo?.installmentCount || 1 };
			form.tokenId = { value: tokenId };
			form.patientAgreement = { value: this.props.gearOrder.patientAgreement || false };
			form.patientNSAAcknowledged = { value: this.props?.gearOrder?.nsaAcknowledged };
			
			form.paypalOrderId = {
				value:
					!physicianInTheLoopRecollection && paymentType === 'paypal'
						? this.props.gearOrder.requisitions[0].paymentInfo.transactionId
						: null
			};

			if (physicianInTheLoopOrder || ukOrder) {
				form.paymentType = { value: 'card' };
			}
		}

		const initialInstallmentCount = this.props.gearOrder?.allPayments?.find(payment => payment.installmentCount > 1)?.installmentCount || 1;
		const initialPaymentPlanType = initialInstallmentCount > 1 ? 'month' : 'full';

		this.handleSubmit = this.handleSubmit.bind(this);
		// Pass handleSubmit to the parent so it can initiate a submit
		if (this.props.setPaymentHandler) {
			this.props.setPaymentHandler(this.handleSubmit);
		}
		this.state = {
			showError: false,
			errorMessage: '',
			sampleDateRequired: false,
			totalPaymentAmount: null,
			fullPayAmounts: {},
			paymentPlanValid: true,
			paymentPlan: initialPaymentPlanType,
			paymentInstallments: initialInstallmentCount,
			paymentInterval: 1,
			authAmounts: {},
			cardRequired: cardRequired,
			checkRequired: checkRequired,
			pageLocked: pageLocked,
			hasPayment: hasPayment,
			tokenId: tokenId,
			focusedInput: null,
			form: form,
			showUpdatedPaymentRequired: false,
			customPaymentAmount: '',
			configErrorFound: null,
			showTestPayment: true,
			payForTestNow: (hasPayment || patientRegistration || (physicianInTheLoopOrder && !this.props.gearOrder.dataConfirmed)),
			expeditedShippingPaymentDetails: {
				cardNo: { value: '' },
				cardCvv: { value: '' },
				cardExpDate: { value: '' },
				cardholderName: { value: '' },
				cardZipCode: { value: '' },
				tokenId: { value: this.props.gearOrder?.practitioner?.shippingCardOnFile ? '9999A' : '' }
			},
			physicianInTheLoopOrder: physicianInTheLoopOrder,
			patientAcknowledgement: '',
			hasAffiliateCode: hasAffiliateCOde,
			nsaAcknowledgement: ''
		};

		this.setPaymentState = this.setPaymentState.bind(this);
		this.togglePaymentType = this.togglePaymentType.bind(this);
		this.submitPaymentInfo = this.submitPaymentInfo.bind(this);
		this.setFormValue = this.setFormValue.bind(this);
		this.validate = this.validate.bind(this);
		this.setTokenId = this.setTokenId.bind(this);
		this.clearTokenId = this.clearTokenId.bind(this);
		this.showPopover = this.showPopover.bind(this);
		this.checkNoInput = null;
		this.cardNoInput = null;
		this.prepayInput = null;
		this.setCheckNoInputRef = (element) => (this.checkNoInput = element);
		this.setCardNoInputRef = (element) => (this.cardNoInput = element);
		this.setPrepayInputRef = (element) => (this.prepayInput = element);
	}
	componentDidMount() {
		this.setPaymentState(this.props);
		this.setPatientAcknowledgementState();
		this.setNSAAcknowledgementState();

		if (!window.grecaptcha) {
			this.loadRecaptchaScript();
		} else {
			this.loadGrecaptchaObject();
		}
	}
	componentDidUpdate(prevProps, prevState, snapshot) {
		// Clear the PayPal order ID (so we show payment controls) if an error happend during order submission
		if (this.props.resetPayPalPayment && !prevProps.resetPayPalPayment) {
			this.setPayPalOrderId(null);
		}
		// Set PaymentState if prices changed or there are shipping charges to collect after Inbound shipping method changed for UK orders.
		const collectShippingChargesForUK = isUKOrder(this.props.gearOrder) && this.props.gearOrder?.shippingChargesUK && Object.keys(this.props.gearOrder.shippingChargesUK).length > 0
												&& Object.values(this.props.gearOrder.shippingChargesUK).reduce((sum, charge) => sum + charge, 0) > 0;
	    
		if (JSON.stringify(prevProps.prices) !== JSON.stringify(this.props.prices) || (collectShippingChargesForUK && prevProps.gearOrder?.inboundShippingMethod !== this.props.gearOrder?.inboundShippingMethod)) {
			this.setPaymentState(this.props);
		}
		if (this.state.focusedInput && this.state.focusedInput !== prevState.focusedInput) {
			this.state.focusedInput.focus();
		}

		// Update patient acknowledgement if the biling method has changed
		if ( (isUKOrder(this.props.gearOrder) && this.getPatientAcknowledgementBillingMethodUK(prevProps.gearOrder) !== this.getPatientAcknowledgementBillingMethodUK(this.props.gearOrder))
			|| (!isUKOrder(this.props.gearOrder) &&this.getPatientAcknowledgementBillingMethod(prevProps.gearOrder) !== this.getPatientAcknowledgementBillingMethod(this.props.gearOrder))) {
			this.setPatientAcknowledgementState();
			this.setNSAAcknowledgementState();
		}

		if (this.props.userInfo.type === 'prc' && !this.props.gearOrder.physicianInTheLoop && !isFullyAccessioned(this.props.gearOrder)) {
			let priceIncrease = false;
			let medicareWithPhysicianCardOnFile = false;
			this.props.prices.forEach((price) => {
				const patientConfirmed = this.props.gearOrder?.workflow?.patientConfirmed;
				
				let reqPayment = this.props.gearOrder.requisitions.find((req) => req.id === price.gearRequisitionId)
					?.paymentInfo;

				// check payments don't have a fullPaymentAmount value and card payments might have an installment cardAuthAmount
				// Use fullPaymentAmount if available, fall back to cardAuthAmount if not
				const paymentAmount = reqPayment?.fullPaymentAmount || reqPayment?.cardAuthAmount;
				const priceWithDiscount = (price.price || 0) - (price.discount?.discountAmount || 0);
				if (reqPayment && paymentAmount < priceWithDiscount) {
					priceIncrease = true;
				} else if (!reqPayment && patientConfirmed && priceWithDiscount > 0) {
					// Patient previously completed confirmation and no payment was required, but now a payment is required
					priceIncrease = true;
				}
				if (reqPayment && reqPayment.tokenId === '9999A' && price.billingMethod === 'Medicare or Tricare') {
					medicareWithPhysicianCardOnFile = true;
				}
			});

			if (
				(this.state.pageLocked || !this.state.payRequired) &&
				(priceIncrease || medicareWithPhysicianCardOnFile)
			) {
				let form = Object.assign({}, this.state.form);
				form.checkNo = { value: '' };
				form.paymentType = { value: '' };
				form.cardNo = { value: '' };
				form.cardCvv = { value: '' };
				form.cardExpDate = { value: '' };
				form.cardholderName = { value: '' };
				form.cardZipCode = { value: '' };
				form.installmentIntervalType = { value: 'full' };
				form.installmentCount = { value: 1 };
				form.tokenId = { value: '' };

				this.setState({
					pageLocked: false,
					payRequired: true,
					showUpdatedPaymentRequired: true,
					form: form,
					checkRequired: false,
					cardRequired: false
				});
			}
		}
	}

	setPaymentState(props) {
		let reqAmounts = {};
		props.prices.forEach((price) => {
			let reqPrice = price.price || 0;

			if (price.discount?.discountType === 'PRICE') {
				// 'PRICE' discounts have the amount to charge in the discountAmount field
				reqAmounts[price.gearRequisitionId] = price.discount?.discountAmount || 0;
			} else {
				// Subtract any discount from price but don't allow the amount to drop below $0
				reqAmounts[price.gearRequisitionId] = Math.max(reqPrice - (price.discount?.discountAmount || 0), 0);
			}
		});

		let totalPayAmt = Object.values(reqAmounts)
			.reduce((accumulator, currentValue) => accumulator + parseFloat(Math.round(currentValue * 100) / 100), 0);
		
		// UK shipping charges
		totalPayAmt += this.ukShippingPaymentAmount();

		let insuranceProvider = props.gearOrder.insurance?.insuranceProvider ?? null;
		let medicarePayRequired = props.prices.some(
			(price) =>
				price.medicarePrice &&
				price.medicarePrice > 0 &&
				(insuranceProvider === 'medicare' || insuranceProvider === 'medicare_railroad')
		);
		let tricarePayRequired = props.prices.some(
			(price) => price.tricarePrice && price.tricarePrice > 0 && insuranceProvider === 'tricare'
		);

		// if medicare was selected, insurance step was skipped, and we have both a medicare and tricare price that
		// do not match, then inform the user no price can be calculated until insurance data is provided
		let showMedicareTricareNotSelectedMessage = false;
		if (
			insuranceProvider === null &&
			props.gearOrder.requisitions.some(
				(requisition) => requisition.billingMethod && requisition.billingMethod.indexOf('Medicare') !== -1
			)
		) {
			showMedicareTricareNotSelectedMessage = props.prices.some((price) => {
				return (
					((price.medicarePrice && price.medicarePrice > 0) ||
						(price.tricarePrice && price.tricarePrice > 0)) &&
					price.medicarePrice !== price.tricarePrice
				);
			});
		}

		const hasAffiliateCode = this.state.hasAffiliateCode
			|| (this.props.gearOrder.physicianInTheLoop && this.props.prices?.some(price => price.discount?.discountType === 'AFFILIATE'));
		// Check for PITL physician fee. We need to collect the fee even if discounts bring the test price to $0
		// Affiliate Code covers all amounts
		// reqs with a 'PRICE' discount will be driven by totalPayAmt instead of hasPitlPhysicianFee
		let hasPitlPhysicianFee = false;
		if (this.props.gearOrder.physicianInTheLoop && !hasAffiliateCode) {
			props.prices.filter((price) => price.discount?.discountType !== 'PRICE')
				.forEach((price) => {
					if (price.items?.some(item => item.feeItem && item.price)) {
						hasPitlPhysicianFee = true;
					}
			});
		}

		let payRequired =
			!this.state.pageLocked &&
			!this.state.configErrorFound &&
			(totalPayAmt > 0 || medicarePayRequired || tricarePayRequired || showMedicareTricareNotSelectedMessage || hasPitlPhysicianFee);

		const isInternational = isInternationalOrder(this.props.gearOrder);

		const paymentPlanEligible = this.props.gearOrder.requisitions.every((req) => {
			let reqPrice = this.props.prices.find((price) => price.gearRequisitionId === req.id);
			const priceMinusDiscount = (reqPrice?.price || 0) - (reqPrice?.discount?.discountAmount || 0);
			return !isInternational && !req.physicianInTheLoop && !isUKOrder(this.props.gearOrder)
				&& req.noInsuranceBillingSelected && reqPrice && (priceMinusDiscount > 100)
				&& reqPrice?.discount?.issueType !== 'Practicum Testing';
		});

		const fullPayAmounts = Object.assign({}, reqAmounts);

		/* Recalculate installment plan values if installments were selected and then prices changed.
		 * This is Necessary if installments were selected before a discount was entered. */
		if (paymentPlanEligible && this.state.paymentInstallments > 1 && this.state.paymentPlan !== 'full') {
			Object.entries(reqAmounts).forEach(([key, value]) => {
				reqAmounts[key] = value/this.state.paymentInstallments;
			});
		}

		const hasPaymentProvided = props.gearOrder?.allPayments?.some(payment => payment.fullPaymentAmount && payment.fullPaymentAmount > 0);
		const ukCardRequired = payRequired && isUKOrder(props.gearOrder) && !hasPaymentProvided;

		this.setState({
			totalPaymentAmount: totalPayAmt,
			fullPayAmounts: fullPayAmounts,
			authAmounts: reqAmounts,
			payRequired: payRequired,
			showMedicareTricareNotSelectedMessage: showMedicareTricareNotSelectedMessage,
			configErrorFound:
				this.props.pricingError || this.props.prices.some((price) => price.configError || price.error),
			// For practitioner accounts, don't show test payment if all prices have been loaded and no payment is required.
			showTestPayment: this.props.userInfo.type !== 'myGDX' || payRequired || !this.isAllPricesLoaded(),
			paymentPlanEligible: paymentPlanEligible,
			cardRequired: (this.state.cardRequired && !hasAffiliateCode) || ukCardRequired,
			hasAffiliateCode: hasAffiliateCode
		});

		// Reset installment values in case an installment was selected but a discount brought the price below the allowed installment threshold
		if (!paymentPlanEligible && this.isAllPricesLoaded()) {
			this.setPaymentPlan("full");
			this.setPaymentInstallments(1);
			this.setPaymentInterval(1);
		}
	}

	togglePaymentType(e) {
		// Reset payment field values when payment type changes
		let form = Object.assign({}, this.state.form);
		form.paymentType.value = e.currentTarget.value;
		form.checkNo = { value: '' };
		form.cardNo = { value: '' };
		form.cardCvv = { value: '' };
		form.cardExpDate = { value: '' };
		form.cardholderName = { value: '' };
		form.cardZipCode = { value: '' };
		form.prepay = { value: '' };
		form.tokenId = { value: '' };

		var paymentType = e.currentTarget.value;
		if (paymentType === 'check') {
			this.setState({
				cardRequired: false,
				checkRequired: true,
				focusedInput: this.checkNoInput
			});
		} else if (paymentType === 'card' || paymentType === 'useExpeditedShipping') {
			this.setState({
				cardRequired: true,
				checkRequired: false,
				focusedInput: this.cardNoInput
			});
		} else if (paymentType === 'prepay') {
			this.setState({
				cardRequired: false,
				checkRequired: false,
				focusedInput: this.prepayInput
			});
		} else {
			this.setState({
				cardRequired: false,
				checkRequired: false,
				focusedInput: null
			});
		}

		if (paymentType === 'useExpeditedShipping') {
			const expeditedDetails = this.state.expeditedShippingPaymentDetails;
			form.cardNo.value = expeditedDetails.cardNo.value;
			form.cardExpDate.value = expeditedDetails.cardExpDate.value;
			form.cardCvv.value = expeditedDetails.cardCvv.value;
			form.cardholderName.value = expeditedDetails.cardholderName.value;
			form.cardZipCode.value = expeditedDetails.cardZipCode.value;
			form.checkNo.value = '';
			form.tokenId.value = '';
		}

		let payForTestNow = this.state.payForTestNow;
		if (paymentType === 'resubmittal' && this.props.userInfo.type !== 'prc') {
			payForTestNow = false;
		}

		this.setState({ form: form, payForTestNow: payForTestNow });
	}

	/**
	 * Update state based on the presence of a PayPal order ID.
	 *
	 * Having an order ID means the PayPal process is complete and we can hide payment controls. 
	 * No order ID probably means an order submission error occurred and we might need to show
	 * payment controls.
	 */
	setPayPalOrderId = (data) => {
		let paypalOrderId = data?.orderId;
		let paymentType;
		if (!!paypalOrderId) {
			paymentType = 'paypal';
		} else {
			paymentType = this.props.gearOrder.requisitions?.[0].paymentInfo?.paymentType ?? 'card';
			/*
			 * data.orderId will be empty when this method is called due to an order submission 
			 * error. Check for a 'paypal' payment with a transaction ID to see if a successful 
			 * payment was saved before the error occurred.
			 */
			paypalOrderId = this.props.gearOrder?.requisitions?.find(
				(req) => req.paymentInfo?.paymentType === 'paypal' && !!req.paymentInfo.transactionId
			)?.paymentInfo?.transactionId;
		}

		let newForm = { ...this.state.form };
		newForm.paymentType = { value: paymentType };
		newForm.paypalOrderId = { value: paypalOrderId ?? null }
		let cardRequired = !paypalOrderId && (paymentType === 'card' || (this.props.gearOrder?.physicianInTheLoop && !this.props.gearOrder.dataConfirmed));
		
		this.setState({
			cardRequired: cardRequired,
			form: newForm
		});
	}

	/**
	 * Build an array of payments to submit when the patient enters a custom payment amount.
	 */
	buildCustomPayments = () => {
		let customPayments = [];
		const customPaymentAmount = this.state.customPaymentAmount;
		if (customPaymentAmount && this.props.gearOrder.requisitions && this.props.gearOrder.requisitions.length) {
			const amountPerReq =
				Math.floor((customPaymentAmount / this.props.gearOrder.requisitions.length) * 100) / 100;
			let remainingAmount = customPaymentAmount;
			// Split the payment evenly among the requisitions
			this.props.gearOrder.requisitions.forEach((req, index, requisitionsArray) => {
				remainingAmount = remainingAmount - amountPerReq;
				let paymentForThisReq = amountPerReq;
				// If this is the last req add any remainder (accounts for rounding issues)
				if (index === requisitionsArray.length - 1) {
					paymentForThisReq += remainingAmount;
				}
				let payment = {
					id: req.paymentInfo ? req.paymentInfo.id : null,
					gearReqId: req.id,
					paymentType: this.state.form.paymentType.value,
					paymentFrom: this.props.userInfo.type,
					tokenId:
						this.state.form.paymentType.value === 'cardOnFile' ? '9999A' : this.state.form.tokenId.value,
					checkNo: this.state.form.checkNo.value,
					cardNo: this.state.form.cardNo.value,
					cardExpDate: this.state.form.cardExpDate.value,
					cardCvv: this.state.form.cardCvv.value,
					cardholderName: this.state.form.cardholderName.value,
					cardZipCode: this.state.form.cardZipCode.value,
					cardAuthAmount: paymentForThisReq,
					fullPaymentAmount: paymentForThisReq
				};

				customPayments.push(payment);
			});
		}
		return customPayments;
	};

	submitPaymentInfo() {
		let orderPayment = {
			// Do not include patientAgreement value when a client submits
			patientAgreement: this.props.userInfo.type !== 'myGDX' ? this.state.form.patientAgreement.value : null,
			payments: [],
			nsaAcknowledged: this.nsaAckRequired() ? this.state.form.patientNSAAcknowledged.value : null,
			recaptcha: this.state.form.captcha?.value
		};
		if (this.state.customPaymentAmount) {
			orderPayment.payments = this.buildCustomPayments();
		} else if (this.state.payForTestNow || !this.state.payRequired || this.state.form.paymentType.value === 'resubmittal') {
			this.props.prices.forEach((price) => {
				var paymentInfo = {};
				let gearReq = this.props.gearOrder.requisitions.find(
					(req) => req.id === price.gearRequisitionId
				)

				paymentInfo.paymentFrom = this.props.userInfo.type;
				paymentInfo.paymentType = this.state.form.paymentType.value;
				if (paymentInfo.paymentType === 'useExpeditedShipping') {
					paymentInfo.paymentType = 'card';
				}

				if (paymentInfo.paymentType === 'prepay') {
					paymentInfo.prcConfirmationNo = this.state.form.prepay.value;
				} else if (paymentInfo.paymentType === 'cardOnFile') {
					paymentInfo.tokenId = '9999A';
				} else if (paymentInfo.paymentType === 'paypal') {
					paymentInfo.tokenId = this.state.form.paypalOrderId?.value;
				} else {
					paymentInfo.checkNo = this.state.form.checkNo.value;
					paymentInfo.tokenId = this.state.form.tokenId.value;
					paymentInfo.cardNo = this.state.form.cardNo.value;
					paymentInfo.cardExpDate = this.state.form.cardExpDate.value;
					paymentInfo.cardCvv = this.state.form.cardCvv.value;
					paymentInfo.cardholderName = this.state.form.cardholderName.value;
					paymentInfo.cardZipCode = this.state.form.cardZipCode.value;
				}

				if (paymentInfo.paymentType === 'card') {
					paymentInfo = this.syncInstallmentInfo(paymentInfo);
				}
				paymentInfo.id = gearReq?.paymentInfo?.id || 0;
				paymentInfo['gearReqId'] = price.gearRequisitionId;
				paymentInfo['cardAuthAmount'] = this.state.authAmounts[price.gearRequisitionId];
				paymentInfo['fullPaymentAmount'] = this.state.fullPayAmounts[price.gearRequisitionId];
				paymentInfo.discount = price.discount && { ...price.discount };

				if (price.discount?.discountType === 'AFFILIATE') {
					paymentInfo.paymentFrom = 'affiliate';
					/* The price was reduced by the discount so the screen would show $0. 
					   We need to undo that so we submit the actual payment amount. */
					paymentInfo.cardAuthAmount = price.price;
					paymentInfo.fullPaymentAmount = paymentInfo.cardAuthAmount;
				}

				/**
				 * 'PRICE' type discounts are backwards (the discountAmount value is actually the 
				 * amount to pay). Flip it around so that the saved discount amount is the price 
				 * reduction.
				 */
				if (price.discount?.discountType === 'PRICE') {
					let amountToPay = this.state.authAmounts[price.gearRequisitionId];
					let totalCharges = price.price;

					const physicianInTheLoop = gearReq?.physicianInTheLoop;

					/**
					 * PITL 'PRICE' discounts also discount the client fee. Add the fee into the
					 * total charge when calculating the final discount amount.
					 */
					if (physicianInTheLoop) {
						const physicianFee = price.items?.find(item => item.feeItem && item.name === 'Physician Fee')?.price || 0;
						totalCharges += Math.min(physicianFee, amountToPay);
					}
					paymentInfo.discount.discountAmount = Math.max(totalCharges - amountToPay, 0);
				}

				// SCR-6962: Submit a payment even when payment is not required so the back-end knows to mark the Payment step as completed
				// SCR-7640: Always submit payments with a discount (In case we have a Complimentary Discount and the charge is $0)
				if (!this.state.payRequired && paymentInfo.id) {
					// HD-77962: Don't submit a payment if payment is not required and a payment was previously saved
				} else if (
					paymentInfo.cardAuthAmount ||
					paymentInfo.fullPaymentAmount ||
					paymentInfo.discount ||
					!this.state.payRequired ||
					paymentInfo.paymentType === 'resubmittal'
				) {
					orderPayment.payments.push(paymentInfo);
				}
			});
		}

		if (this.isShowExpeditedShippingPayment() && this.state.expeditedShippingPaymentDetails) {
			orderPayment.payments.push({
				paymentType: 'expeditedShipping',
				paymentFrom: this.props.userInfo.type,
				cardNo: this.state.expeditedShippingPaymentDetails.cardNo.value,
				cardCvv: this.state.expeditedShippingPaymentDetails.cardCvv.value,
				cardExpDate: this.state.expeditedShippingPaymentDetails.cardExpDate.value,
				cardholderName: this.state.expeditedShippingPaymentDetails.cardholderName.value,
				cardZipCode: this.state.expeditedShippingPaymentDetails.cardZipCode.value,
				tokenId: this.state.expeditedShippingPaymentDetails.tokenId?.value,
				saveForLater: !!this.state.expeditedShippingPaymentDetails.saveForLater?.value,
				gearOrderId: this.props.gearOrder.id,
				cardAuthAmount: this.props.gearOrder.expeditedShippingCharge,
				fullPaymentAmount: this.props.gearOrder.expeditedShippingCharge
			});
		}

		//For UK orders if there are shipping charges then we need to add a payment for the shipping charges.
		//This is in addition to any other payments that may be required for test charges.
		//If insurance is the only billing method selected then this will be the only payment.
		const ukShippingChargesTotal = this.ukShippingPaymentAmount();
		if(ukShippingChargesTotal > 0) {
			orderPayment.payments.push({
				paymentType: 'ukShippingCharge',
				paymentFrom: this.props.userInfo.type,
				checkNo:this.state.form.checkNo.value,
				cardNo: this.state.form.cardNo.value,
				cardCvv: this.state.form.cardCvv.value,
				cardExpDate: this.state.form.cardExpDate.value,
				cardholderName: this.state.form.cardholderName.value,
				cardZipCode: this.state.form.cardZipCode.value,
				tokenId: this.state.form.tokenId?.value,
				saveForLater: !!this.state.form.saveForLater?.value,
				gearOrderId: this.props.gearOrder.id,
				cardAuthAmount: ukShippingChargesTotal,
				fullPaymentAmount: ukShippingChargesTotal
			});
		}

		// Include browser details for UK payments
		if (isUKOrder(this.props.gearOrder)) {
			orderPayment.browserDetails = {
				locale: navigator.language,
				browserColorDepth: window.screen.colorDepth,
				browserScreenHeight: window.screen.height,
				browserScreenWidth: window.screen.width,
				browserTimeZoneOffset: new Date().getTimezoneOffset()
			};
		}

		if (this.props.onSubmit) {
			this.props.onSubmit(orderPayment);
			if (this.isShowRecaptcha() && this.state.form.captcha?.value) {
				this.resetReCaptcha();
			}
		}
		return orderPayment;
	}

	//For UK orders payment is required from patient if there are shipping charges and the total shipping charges is greater than 0.
	ukShippingPaymentAmount = () => {
		if (this.props.userInfo.type !== 'prc' || !isUKOrder(this.props.gearOrder) || !this.props.gearOrder.shippingChargesUK) {
			return 0;
		}
		return Object.values(this.props.gearOrder.shippingChargesUK).reduce((sum, charge) => sum + charge, 0);
	}

	setPaymentPlanValidity(validity) {
		this.setState({
			paymentPlanValid: validity
		});
	}
	setPaymentPlan(choice) {
		let form = Object.assign({}, this.state.form);
		form.installmentIntervalType.value = choice;
		this.setState({
			paymentPlan: choice
		});
	}
	setPaymentInstallments(i) {
		let form = Object.assign({}, this.state.form);
		form.installmentCount.value = i;
		this.setState({
			paymentInstallments: i,
			form: form
		});
	}
	setPaymentInterval(i) {
		this.setState({
			paymentInterval: i
		});
	}
	setAuthAmounts(i) {
		this.setState({
			authAmounts: i
		});
	}

	setCustomPayment = (evt) => {
		let amount = evt.target.value;
		amount = amount < 0 ? 0 : amount;
		this.setState({
			customPaymentAmount: +amount
		});
	};
	setTokenId(evt) {
		let form = Object.assign({}, this.state.form);
		form.tokenId.value = evt.target.value;
		this.setState({
			tokenId: evt.target.value,
			form: form
		});
	}
	clearTokenId(evt) {
		let form = Object.assign({}, this.state.form);
		form.cardNo.value = evt.target.value;
		this.setState({
			tokenId: '',
			form: form
		});
	}
	syncInstallmentInfo(payment) {
		if (this.state.paymentPlan != null) {
			payment['installmentIntervalType'] = this.state.paymentPlan;
			payment['installmentCount'] = this.state.paymentInstallments;
			payment['installmentInterval'] = this.state.paymentInterval;
		}
		return payment;
	}
	
	setFormValue = (e) => {	
		let fieldName = e.currentTarget.dataset.fieldname;
		let value = e.currentTarget.type === 'checkbox' ? e.currentTarget.checked : e.currentTarget.value;	
		this.setState((prevState) => {
			let newForm = { ...prevState.form };

			//Add input formatting for card expiration date. Auto add the '/' after MM.
			if (fieldName === 'cardExpDate') {
				// Remove all non-digit and non-slash characters
				let ccExpInput = String(value).replace(/[^\d/]/g, '');
				const prevValue = newForm.cardExpDate.value || '';
				const isDeleting = ccExpInput.length < prevValue.length;

				// Only auto-insert '/' if user is typing forward and there is no slash yet
				if (!isDeleting && ccExpInput.length === 2 && !ccExpInput.includes('/')) {
					ccExpInput = ccExpInput + '/';
				}
				// If user retyped the slash or pasted with multiple slashes or in more than one slash in added then keep only one.
				if ((ccExpInput.match(/\//g) || []).length > 1) {
					const parts = ccExpInput.split('/');
					ccExpInput = parts[0].slice(0, 2) + '/' + parts.slice(1).join('').slice(0, 2);
				}
				value = ccExpInput;
			}

			newForm[fieldName].value = value;
			return { form: newForm };
		});		
	}

	validate(form) {
		let validatedForm = Object.assign({}, form);
		Object.values(validatedForm).forEach((prop) => {
			prop.valid = true;
			prop.message = '';
		});

		if ((this.state.payRequired || this.state.customPaymentAmount) && this.state.payForTestNow) {
			if (!validatedForm.paymentType.value) {
				validatedForm.paymentType.valid = false;
				validatedForm.paymentType.message = 'Please select a payment type.';
			}

			// SCR-4778 - Payment Page: Make Check number optional
			//          if (this.state.checkRequired && !this.state.hasPrcCode && !validatedForm.checkNo.value) {
			//              validatedForm.checkNo.valid = false;
			//              validatedForm.checkNo.message = "Please provide a check number.";
			//          }

			if (this.state.cardRequired && !validatedForm.prepay.value && !this.state.tokenId) {
				if (!validatedForm.cardNo.value) {
					validatedForm.cardNo.valid = false;
					validatedForm.cardNo.message = 'Please provide a card number.';
				} else if (validatedForm.cardNo.value.length < 12 || validatedForm.cardNo.value.length > 19) {
					validatedForm.cardNo.valid = false;
					validatedForm.cardNo.message = 'Card number must be between 12 and 19 digits.';
				}
				if (!validatedForm.cardExpDate.value) {
					validatedForm.cardExpDate.valid = false;
					validatedForm.cardExpDate.message = 'Please provide an expiration date.';
				} else if (!new RegExp('^(0[1-9]|1[0-2])/(1[8-9]|[2-9][0-9])$').test(validatedForm.cardExpDate.value)) {
					validatedForm.cardExpDate.valid = false;
					validatedForm.cardExpDate.message = 'Please provide a valid expiration date.';
				}
				if (!validatedForm.cardCvv.value) {
					validatedForm.cardCvv.valid = false;
					validatedForm.cardCvv.message = 'Please provide a CVV code.';
				}
				if (!validatedForm.cardholderName.value) {
					validatedForm.cardholderName.valid = false;
					validatedForm.cardholderName.message = 'Please provide a cardholder name.';
				}
				if (!validatedForm.cardZipCode.value) {
					validatedForm.cardZipCode.valid = false;
					validatedForm.cardZipCode.message = 'Please provide a billing zip code.';
				}
			}

			// only validate the credit card token if an admin user - valid tokens are 6 characters long or 9999A for practitioner cards on file
			if (
				this.props.userInfo.adminUser === 'true' &&
				validatedForm.tokenId.value &&
				!(validatedForm.tokenId.value.length === 6 || validatedForm.tokenId.value === '9999A')
			) {
				validatedForm.tokenId.valid = false;
				validatedForm.tokenId.message = 'Please provide a valid token id.';
			}

			if (validatedForm.paymentType.value === 'prepay') {
				if (!validatedForm.prepay.value) {
					validatedForm.prepay.valid = false;
					validatedForm.prepay.message = 'Please provide your 6-digit confirmation code.';
				} else if (validatedForm.prepay.value.length !== 6) {
					validatedForm.prepay.valid = false;
					validatedForm.prepay.message = 'Please provide a valid 6-digit confirmation code.';
				}
			}

			if (!validatedForm.installmentIntervalType) {
				validatedForm.installmentIntervalType.valid = false;
				validatedForm.installmentIntervalType.message = 'Please select a payment option.';
			}
			if (
				validatedForm.installmentIntervalType.value === 'month' &&
				(validatedForm.installmentCount.value < 2 || validatedForm.installmentCount.value > 4)
			) {
				validatedForm.installmentCount.valid = false;
				validatedForm.installmentCount.message = 'Please select a value between 2 and 4.';
			}

			if (this.props.userInfo.type === 'prc' && !this.state.form.captcha?.value) {
				validatedForm.captcha = { valid: false, message: 'Please complete the CAPTCHA.' };
			}
		}

		if (
			this.props.userInfo.type !== 'myGDX' &&
			!this.props.gearOrder.patientAgreement &&
			!validatedForm.patientAgreement.value &&
			!this.state.configErrorFound
		) {
			validatedForm.patientAgreement.valid = false;
			validatedForm.patientAgreement.message = 'Patient/Responsible Party Acknowledgement is required.';
		}

		if (this.nsaAckRequired() && !validatedForm.patientNSAAcknowledged.value) {
			validatedForm.patientNSAAcknowledged.valid = false;
			validatedForm.patientNSAAcknowledged.message = 'Non Surprise Act(NSA) Acknowledgement is required.';
		}

		return validatedForm;
	}

	nsaAckRequired = () => {		
		let nsaRequired = false;		
		const ptShippingCountry = this.props.gearOrder?.patientInfo?.addresses?.find((a) => a.type === 'shipping')?.country;				
		const billingMethod = this.getPatientAcknowledgementBillingMethod(this.props.gearOrder);		
		
		if (!isUKOrder(this.props.gearOrder) 
			&& this.props.userInfo.type !== 'myGDX' &&
			(!ptShippingCountry || ptShippingCountry === 'United States') &&
			!this.state.configErrorFound &&
			!this.props.gearOrder.physicianInTheLoop &&			
			(!this.state.pageLocked || !this.props.gearOrder.nsaAcknowledged) &&
			(billingMethod === process.env.REACT_APP_BILLING_INSURANCE_VALUE
				||billingMethod === process.env.REACT_APP_BILLING_MEDICARE_VALUE
				|| billingMethod === process.env.REACT_APP_BILLING_NO_INSURANCE_VALUE) &&
			  !isFullyAccessioned(this.props.gearOrder)
			  ) {
				nsaRequired = true;
			}	
			
		return nsaRequired;		
	}

	handleSubmit(event) {
		event.preventDefault();

		// Skip captcha validation for 3D Secure Credorax challenges
		if (event?.type === '3DSChallengeSuccess') {
			this.setCaptchaValue(event.detail?.threeDSServerTransID);
		}

		// Don't verify any fields or update any data when the page is locked and patient agreement is not required
		let patientAgreementRequired =
			this.props.userInfo.type !== 'myGDX' &&
			!this.props.gearOrder.patientAgreement &&
			!this.state.configErrorFound;

		if (
			(this.state.pageLocked && !patientAgreementRequired && !this.nsaAckRequired()) ||
			(this.state.configErrorFound && !this.state.customPaymentAmount)
		) {
			if (this.props.onSubmit) {
				this.props.onSubmit();
				return;
			}
		}

		// Only validate expedited payment details if expedited payment is required
		let expeditedShippingPaymentDetails = null;
		if (this.isShowExpeditedShippingPayment() && !this.props.gearOrder.expeditedShippingPayment) {
			expeditedShippingPaymentDetails = validateCreditCardForm(this.state.expeditedShippingPaymentDetails);
		}

		this.setState(
			{
				form: this.validate(this.state.form),
				expeditedShippingPaymentDetails: expeditedShippingPaymentDetails
			},
			() => {
				if (
					Object.values(this.state.form).every((prop) => prop.valid) &&
					(!expeditedShippingPaymentDetails ||
						expeditedShippingPaymentDetails.tokenId?.valid ||
						Object.values(expeditedShippingPaymentDetails).every((prop) => prop.valid))
				) {
					this.submitPaymentInfo();
				} else {
					scrollToMessage();
				}
			}
		);
	}

	showPopover(event, message) {
		event.preventDefault();
		let popover = window.$(event.currentTarget).data('bs.popover');
		if (!popover) {
			window.$(event.currentTarget).popover({
				content: message,
				html: true,
				placement: 'bottom',
				trigger: 'focus',
				container: '#reactRoot .banner.section'
			});
		}
		window.$(event.currentTarget).popover('show');
	}

	isAllPricesLoaded = () => {
		let loadedPrices = this.props.prices.filter((price) => !price.placeholder);
		let reqsRequiringPrices = this.getReqsRequiredPrices(this.props.gearOrder);

		return this.props.doNotQuotePrices || loadedPrices.length === reqsRequiringPrices.length;
	};

	getReqsRequiredPrices = (gearOrder) => {
		return gearOrder.requisitions.filter(
			(req) => req.billingMethod && req.billingMethod !== process.env.REACT_APP_BILLING_PHYSICIAN_ACCOUNT_VALUE
			&& !(req.physicianInTheLoop && req.accessionNo)
		);
	}

	/**
	 * Validate expedited payment input field changes and update state
	 * @param event The HTML event that triggered this method
	 */
	handleExpeditedPaymentInputChange = (event) => {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const valid = target.type === 'checkbox' ? true : !!value || false;
		const fieldName = target.name;

		let newField = {
			value: value,
			valid: valid
		};

		// Only validate when the value is empty. We don't want to do other validation like credit card length
		// when typing in the field
		newField.message = value ? '' : validateCreditCardField(fieldName, newField).message;

		this.setState(
			(prevState) => {
				return {
					expeditedShippingPaymentDetails: {
						...prevState.expeditedShippingPaymentDetails,
						[fieldName]: newField
					}
				};
			},
			() => {
				if (this.state.form.paymentType.value === 'useExpeditedShipping') {
					this.copyExpeditedPaymentToCreditCard(this.state.expeditedShippingPaymentDetails);
				}
			}
		);
	};

	/**
	 * Copy the expedited payment fields into the 'Test Charges' credit card fields.
	 * @param expeditedPaymentDetails The expedited payment details
	 */
	copyExpeditedPaymentToCreditCard = (expeditedPaymentDetails) => {
		this.setState({
			form: {
				...this.state.form,
				cardNo: expeditedPaymentDetails.cardNo,
				cardCvv: expeditedPaymentDetails.cardCvv,
				cardExpDate: expeditedPaymentDetails.cardExpDate,
				cardholderName: expeditedPaymentDetails.cardholderName,
				cardZipCode: expeditedPaymentDetails.cardZipCode
			}
		});
	};

	/**
	 * Checks if the expedited shipping charges section should be displayed.
	 * It should display for 'myGDX' users when the gearOrder has an expedited shipping charge > $0.
	 */
	isShowExpeditedShippingPayment = () => {
		// Coerce to boolean
		return !!(this.props.userInfo.type === 'myGDX' && this.props.gearOrder.expeditedShippingCharge);
	};

	setPayForTestNow = (event) => {
		// Clear the payment type when PayForTestNow changes
		let form = Object.assign({}, this.state.form);
		form.paymentType.value = null;

		this.setState({
			payForTestNow: event.target.value === 'true',
			form: form,
			cardRequired: false,
			checkRequired: false,
			focusedInput: null
		});
	}

	editShippingMethod = () => {
		this.props.updateStep(this.props.gearOrder, 'patient');
	}

	isHidePaymentSection = () => { 
		return (!this.state.payRequired && !this.state.customPaymentAmount) || this.state.pageLocked || !this.isAllPricesLoaded() || !this.state.showTestPayment;
	}

	/**
	 * Determine if the order is for commercial insurance.
	 *
	 * An order is commercial insurance if the selected billing method is the Commercial Insurance
	 * option or if the order contains insurance details with a non-Medicare provider.
	 *
	 * @param gearOrder The order to check
	 * @returns boolean - True if the order is for commercial insurance, false otherwise.
	 */
	isCommercialInsuranceOrder = (gearOrder) => {
		// Has commercial insurance billing method
		if (gearOrder?.requisitions?.some(req => req.billingMethod === process.env.REACT_APP_BILLING_INSURANCE_VALUE)) {
			return true;
		}

		// Has non-Medicare insurance provider
		const medicareProviders = ['medicare', 'medicaid', 'tricare', 'medicare_railroad'];
		if (gearOrder?.insurance?.insuranceProvider) {
			if (medicareProviders.includes(gearOrder.insurance.insuranceProvider)) {
				return false;
			}
			if (gearOrder?.secondaryInsurance?.insuranceProvider) {
				if (medicareProviders.includes(gearOrder.secondaryInsurance.insuranceProvider)) {
					return false;
				}
			}
			return true;
		}

		return false;
	}

	setPatientAcknowledgementState() {
		if (this.props.userInfo.type !== 'myGDX' &&
				!this.props.gearOrder.patientAgreement &&
				!this.state.configErrorFound) {
			getPatientAcknowledgement(this.props.gearOrder.id)
			.then(json => {
				this.setState({
					patientAcknowledgement: json.html
				})
			})
			.catch(e => {
				this.setState({
					patientAcknowledgementError: e.message || 'An unexpected error has occurred.'
				});
			})
		}
	}

	setNSAAcknowledgementState() {
		if (this.nsaAckRequired()) {
			getNSAAcknowledgement(this.props.gearOrder.id)
			.then(json => {				
				this.setState({
					nsaAcknowledgement: json.html
				})
			})
			.catch(e => {				
				this.setState({
					nsaAcknowledgementError: e.message || 'An unexpected error has occurred.'
				});
			})
		}
	}

	/**
	 * Get the Billing Method that will be used when displaying the Patient Acknowledgement
	 */
	getPatientAcknowledgementBillingMethod = (gearOrder) => {
		if (gearOrder?.requisitions?.find(req => req?.billingMethod === process.env.REACT_APP_BILLING_INSURANCE_VALUE)) {
			return process.env.REACT_APP_BILLING_INSURANCE_VALUE;
		} else if (gearOrder?.requisitions?.find(req => req?.billingMethod === process.env.REACT_APP_BILLING_MEDICARE_VALUE)) {
			return process.env.REACT_APP_BILLING_MEDICARE_VALUE;
		} else if (gearOrder?.requisitions?.find(req => req?.billingMethod === process.env.REACT_APP_BILLING_PHYSICIAN_ACCOUNT_VALUE)) {
			return process.env.REACT_APP_BILLING_PHYSICIAN_ACCOUNT_VALUE;
		}

		return process.env.REACT_APP_BILLING_NO_INSURANCE_VALUE;
	}

	getPatientAcknowledgementBillingMethodUK = (gearOrder) => {
		if(gearOrder?.requisitions?.find(req => req?.billingMethod?.startsWith(process.env.REACT_APP_BILLING_PAYMENT_ENCLOSED_VALUE))) {
			const req = gearOrder?.requisitions?.find(req => req?.billingMethod?.startsWith(process.env.REACT_APP_BILLING_PAYMENT_ENCLOSED_VALUE));
			return req?.billingMethod;
		} else if (gearOrder?.requisitions?.find(req => req?.billingMethod === process.env.REACT_APP_BILLING_ONLY_INSURANCE_VALUE)) {
			return process.env.REACT_APP_BILLING_ONLY_INSURANCE_VALUE;
		} else if (gearOrder?.requisitions?.find(req => req?.billingMethod === process.env.REACT_APP_BILLING_ONLINE_ORDER_VALUE)) {
			return process.env.REACT_APP_BILLING_ONLINE_ORDER_VALUE;
		} else if (gearOrder?.requisitions?.find(req => req?.billingMethod === process.env.REACT_APP_BILLING_PHYSICIAN_ACCOUNT_VALUE)) {
			return process.env.REACT_APP_BILLING_PHYSICIAN_ACCOUNT_VALUE;
		} 

		return process.env.REACT_APP_BILLING_ONLY_INSURANCE_VALUE;
	}

	/**
	 * Returns true if the order has a recollectionFor value or if every requisition on the order has an xComId
	 */
	isResubmittalOrder = (gearOrder) => {
		return this.props.gearOrder?.recollectionFor || this.props.gearOrder?.requisitions?.every((req) => req.xComId);
	}

	isShowRecaptcha = () => {
		return this.props.userInfo.type === 'prc' && !this.isHidePaymentSection();
	}

	setCaptchaValue = (value) => {
		this.setState((prevState) => {
			let newForm = { ...prevState.form };
			newForm.captcha = {
				value: value,
				valid: value !== false,
				message: ''
			};
			return { form: newForm };
		});
	}

	/**
	 * Reset the ReCaptcha
	 */
	resetReCaptcha = () => {
		if (this.state.grecaptchaObject?.reset) {
			this.state.grecaptchaObject.reset();
		}
		this.setCaptchaValue(null);
	};

	/**
	 * Attempt to store the window.grecaptcha value in state.
	 * If the value is not available, try again after 500 ms
	 */
	loadGrecaptchaObject = () => {
		// Setting grecaptchaObject doesn't always force a re-render because of how it is a reference to window.grecaptcha
		// The scriptCount value is to make sure state is refreshed and a re-render happens each time this method is called
		this.setState((prevState) => ({
			scriptCount: (prevState.scriptCount || 0) + 1
		}));
		const newObj = window.grecaptcha;

		if (!newObj?.reset) {
			setTimeout(() => {
				this.loadGrecaptchaObject();
			}, 500);
		} else {
			this.setState({ grecaptchaObject: newObj });
		}
	};

	/**
	 * Load the Google ReCaptcha script, which will create the window.grecaptcha object
	 */
	loadRecaptchaScript = () => {
		const script = document.createElement('script');
		script.src = '//www.google.com/recaptcha/api.js';
		script.type = 'text/javascript';
		document.head.appendChild(script);
		this.loadGrecaptchaObject();
	};

	/**
	 * Creates the JSX for the "Test Charges" payment section
	 */
	buildTestChargesDisplay = () => {
		let patientAgreementRequired =
			this.props.userInfo.type !== 'myGDX' &&
			!this.state.configErrorFound &&
			(!this.state.pageLocked || !this.props.gearOrder.patientAgreement);

		let tokenIdHelp = null;
		if (this.props.gearOrder.requisitions?.[0]?.paymentInfo?.tokenId) {
			tokenIdHelp = (
				<FieldLevelHelp
					helpText={
						'Credit Card payment was previously submitted and generated token ' +
						this.props.gearOrder.requisitions[0].paymentInfo.tokenId
					}
					linkText=""
				/>
			);
		}

		let allPricesLoaded = this.isAllPricesLoaded();
		let message = null;
		if (this.props.slowFetch) {
			message = (
				<AlertMessage type="warning">
					Price calculation is taking longer than expected. Calculations can take up to a minute. If no price
					is returned, please contact Genova or consult our Fee Schedule for price.
				</AlertMessage>
			);
		} else if (this.state.configErrorFound && this.props.gearOrder.physicianInTheLoop) {
			message = (
				<AlertMessage type="warning" additionalCssClass="mt-0">
					We are having difficulty retrieving your price. Please try again or call us at {getCustomerCareNumber(this.props?.gearOrder)} or
					contact <a href="/contact" target='_blank'>Customer Support</a> if the problem continues.
					<br />
					<button
						className="btn btn-primary btn-sm rounded-pill"
						style={{ paddingLeft: '0' }}
						title="Reload Prices"
						onClick={this.props.reloadPrices}
					>
						<i className="fa fa-refresh " aria-hidden="true"></i>Try Again
					</button>
				</AlertMessage>
			);
		} else if (this.state.configErrorFound) {
			message = (
				<AlertMessage type="warning">
					We are having difficulty retrieving your price. Please contact Genova or consult our Fee Schedule.
				</AlertMessage>
			);
		} else if (this.state.showMedicareTricareNotSelectedMessage) {
			message = (
				<AlertMessage type="info">
					Price cannot be determined until the Insurance step is completed.
				</AlertMessage>
			);
		}

		const isPaymentPlan = this.state.paymentPlanEligible && this.props.gearOrder?.allPayments.some(payment => payment.installmentCount > 1);
		const installmentPayments = this.props.gearOrder?.allPayments?.filter(payment => payment.installmentCount > 1);
		const paymentInstallmentCount = installmentPayments?.[0]?.installmentCount;
		const fullPaymentAmount = installmentPayments?.reduce((accumulator, payment) => accumulator + payment.fullPaymentAmount, 0);

		const patientRegistration = this.props.userInfo.type === 'prc';

		const hidePaymentSection = this.isHidePaymentSection();
		const isCommercialInsurance = this.isCommercialInsuranceOrder(this.props.gearOrder);

		const isResubmittalOrder = this.isResubmittalOrder(this.props.gearOrder);

		const isCovidRegistration = this.props.gearOrder?.requisitions.every(gearReq => gearReq.covidRegistration || gearReq.omsOrderableItemId === 902);

		// Show Discount input when at least one of the reqs is Client Bill and no other reqs require payment
		const showPhysicianDiscountInput = !this.state.payRequired && this.props.gearOrder?.requisitions.some(req => req.physicianBillingSelected);

		const ukOrder = isUKOrder(this.props.gearOrder);

		const displayNSAAck = !isUKOrder(this.props.gearOrder) && !this.props.gearOrder.physicianInTheLoop && (this?.state?.nsaAcknowledgement || this.state?.nsaAcknowledgementError);
		const displayPatientAck = !(this.props.userInfo.type === 'myGDX' || this.props.gearOrder.patientAgreement || this.state.configErrorFound);

		return (
			<>
				{(isCommercialInsurance && !isCovidRegistration && !isUKOrder(this.props.gearOrder)) && (
					<>
						<InsurancePaymentDisclaimer gearOrder={this.props.gearOrder} prices={this.props.prices} doNotQuotePrices={this.props.doNotQuotePrices} />
						{patientRegistration && <BillingFaqLink ukClient={isUKOrder(this.props.gearOrder)} />}
					</>
				)}

			<PanelWrapper condition={true}>
				{/* Pay for test now selection */}
				{(this.isShowExpeditedShippingPayment() && !patientRegistration) && (
					<h3 className="mt-0">Test Charges</h3>
				)}
				{this.state.showTestPayment && !patientRegistration && this.state.payRequired && !this.state.physicianInTheLoopOrder && (
					<>
						{isResubmittalOrder && (
							<div className="radio">
								<label>
									<input
										type="radio"
										name="payForTestNow"
										id="payForTestNow_resubmittal"
										value="resubmittal"
										checked={this.state.form?.paymentType?.value === 'resubmittal'}
										onChange={this.togglePaymentType}
									/>
									Payment was provided with original order
								</label>
							</div>
						)}
						{!ukOrder && (
						<>
						<div className="radio">
							<label>
								<input
									type="radio"
									name="payForTestNow"
									id="payForTestNow_no"
									value="false"
									checked={!this.state.payForTestNow && this.state.form?.paymentType?.value !== 'resubmittal'}
									onChange={this.setPayForTestNow}
								/>
								My patient will provide payment later
							</label>
						</div>
						<div className="radio">
							<label>
								<input
									type="radio"
									name="payForTestNow"
									id="payForTestNow_yes"
									value="true"
									checked={this.state.payForTestNow}
									onChange={this.setPayForTestNow}
								/>
								I will provide payment for this test now
							</label>
						</div>
						</>
						)}
						{(this.state.form?.paymentType?.value === 'resubmittal') && (
							<ResubmittalPaymentAlert />
						)}
					</>
				)}

				{/* Show price even when not asking for payment */}
				{(!this.state.payForTestNow) && (
					// Show the Discount Code input if we have a Client Bill req and no other reqs require payment
					showPhysicianDiscountInput
						? <PriceView
							gearOrder={this.props.gearOrder}
							prices={this.props.prices}
							allPricesLoaded={allPricesLoaded}
							configErrorFound={this.state.configErrorFound}
							showPopover={this.showPopover}
							doNotQuotePrices={this.props.doNotQuotePrices}
							discount={this.state.discount}
							pageLocked={this.state.pageLocked}
							applyDiscount={this.props.applyDiscount}
						/>
						: <PriceView
							gearOrder={this.props.gearOrder}
							prices={this.props.prices}
							allPricesLoaded={allPricesLoaded}
							configErrorFound={this.state.configErrorFound}
							showPopover={this.showPopover}
							doNotQuotePrices={this.props.doNotQuotePrices}
						/>
				)}

				{this.state.payForTestNow && (
					<>
					 {!isUKOrder(this.props.gearOrder) && (
						<AlertMessage display={this.state.pageLocked && this.state.hasPayment && !this.state.physicianInTheLoopOrder} type="warning">
							<strong>
								Your payment is pending and will be charged once we begin processing your order. If you
								need to make changes, please call us at {getCustomerCareNumber(this.props?.gearOrder)}.
							</strong>
						</AlertMessage>
					 )}
						<AlertMessage type="info" display={patientRegistration && !this.state.physicianInTheLoopOrder}>
							The cost displayed is only as accurate as the information you provided. The final charges
							are determined by the services performed.
						</AlertMessage>
						<div hidden={!this.state.showError} className="alert alert-danger" role="alert">
							<strong>{this.state.errorMessage}</strong>
							<br />
						</div>
						{message}
						<PriceView
							gearOrder={this.props.gearOrder}
							prices={this.props.prices}
							allPricesLoaded={allPricesLoaded}
							configErrorFound={this.state.configErrorFound}
							showPopover={this.showPopover}
							doNotQuotePrices={this.props.doNotQuotePrices}
							discount={this.state.discount}
							pageLocked={this.state.pageLocked || !!this.state.form?.paypalOrderId?.value}
							applyDiscount={this.props.applyDiscount}
						/>
						{this.state.pageLocked && isPaymentPlan && (
							 <div>
								 <span>
									 This order is enrolled in a payment plan. The credit card on file will be charged <strong>${fullPaymentAmount}</strong> over <strong>{paymentInstallmentCount}</strong> consecutive months.
								 </span>
							 </div>
						)}
						{!hidePaymentSection && (
							<div id="payment-section">
								{/* SCR-8729 */}
								{/* {(this.props.gearOrder.physicianInTheLoop && !this.props.gearOrder.pitlRecollectionOrderSummary) && (
									<div style={{ marginLeft: '20px' }}>
										<PayPalCheckout
											gearOrder={this.props.gearOrder}
											prices={this.props.prices}
											paypalOrderId={this.state.form.paypalOrderId?.value}
											handleApprovedPayment={this.setPayPalOrderId}
											buttonContainer={PaypalButtonContainer}
										/>
									</div>
								)} */}
								<form
									onSubmit={this.handleSubmit}
									className="form-horizontal"
									autoComplete="off"
									noValidate
								>
									{/* 'submit' button is required to make submit on enter work */}
									<input type="submit" style={{ display: 'none' }} />
									<div id="gearPayment">
										{(!this.state.physicianInTheLoopOrder && !ukOrder) && (
											<h4>
												Payment Type<span className="text-danger">*</span>
											</h4>
										)}
										{this.state.form.paymentType.valid === false && (
											<span className="validation-message text-danger">
												{this.state.form.paymentType.message}
											</span>
										)}
										{(this.isShowExpeditedShippingPayment() && this.state.expeditedShippingPaymentDetails?.cardNo?.value) && (
											<div
												className={
													'radio ' +
													(this.state.form.paymentType.valid === false ? 'has-error' : '')
												}
											>
												<label htmlFor="reuse-expedited-payment">
													<input
														id="reuse-expedited-payment"
														name="paymentType"
														type="radio"
														value="useExpeditedShipping"
														onClick={this.togglePaymentType}
														defaultChecked={
															this.state.form.paymentType.value === 'useExpeditedShipping'
														}
													/>
													Use the payment details I entered for shipping charges
												</label>
											</div>
										)}
										{(this.props.userInfo.type === 'myGDX' && !this.state.physicianInTheLoopOrder) &&
											this.props.gearOrder.practitioner.cardOnFile && (
												<div
													className={
														'radio ' +
														(this.state.form.paymentType.valid === false ? 'has-error' : '')
													}
												>
													<label id="cardOnFileInput" htmlFor="cardOnFilePayment">
														<input
															id="cardOnFilePayment"
															name="paymentType"
															type="radio"
															value="cardOnFile"
															onClick={this.togglePaymentType}
															defaultChecked={
																this.state.form.paymentType.value === 'cardOnFile'
															}
														/>
														Practitioner's Credit Card on File
													</label>
												</div>
											)}
										{(!this.state.physicianInTheLoopOrder && !ukOrder) && (
											<div
												className={
													'radio ' +
													(this.state.form.paymentType.valid === false ? 'has-error' : '')
												}
											>
												<label htmlFor="checkPayment">
													<input
														id="checkPayment"
														name="paymentType"
														type="radio"
														value="check"
														onClick={this.togglePaymentType}
														defaultChecked={this.state.form.paymentType.value === 'check'}
													/>
													Check
												</label>
											</div>
										)}
										{this.state.checkRequired && (
											<div id="checkInfoSection" className="well payment-details">
												<p className="text-default">
													<strong>Please enter check information.</strong>
													<br />
												</p>
												<div
													className={
														'form-group ' +
														(this.state.form.checkNo.valid === false ? 'has-error' : '')
													}
												>
													<label className="col-md-2 control-label" htmlFor="checkNo">
														Check No
													</label>
													<div className="col-md-3">
														<input
															type="text"
															id="checkNo"
															name="paymentField"
															placeholder="Enter Check Number"
															defaultValue={
																this.props.gearOrder.requisitions[0].paymentInfo &&
																this.props.gearOrder.requisitions[0].paymentInfo.checkNo
																	? this.props.gearOrder.requisitions[0].paymentInfo
																			.checkNo
																	: ''
															}
															ref={this.setCheckNoInputRef}
															onChange={this.setFormValue}
															data-fieldname="checkNo"
														/>
														{this.state.form.checkNo.valid === false && (
															<div className="validation-message text-danger">
																{this.state.form.checkNo.message}
															</div>
														)}
													</div>
												</div>
											</div>
										)}
										{(!this.state.physicianInTheLoopOrder && !ukOrder) && (
											<div
												className={
													'radio ' +
													(this.state.form.paymentType.valid === false ? 'has-error' : '')
												}
											>
												<label htmlFor="cardPayment">
													<input
														id="cardPayment"
														name="paymentType"
														type="radio"
														value="card"
														onClick={this.togglePaymentType}
														defaultChecked={this.state.form.paymentType.value === 'card'}
													/>
													{this.state.paymentPlanEligible ? 'Credit Card / Payment Plan' : 'Credit Card' }
												</label>
											</div>
										)}
										{(this.state.cardRequired && this.state.form.paymentType.value !== 'useExpeditedShipping') && (
											<div id="cardInfoSection" className="row well payment-details">
												<p className="text-default">
													<strong>Please enter credit card information.</strong>
													<br />
													<em>
														<small>
															<AcceptedCreditCards isUkClient={ukOrder} />
														</small>
													</em>
												</p>
												{this.props.userInfo.adminUser === 'true' && (
													<div className="row">
														<div
															className={
																'form-group col-md-6 ' +
																(this.state.form.tokenId.valid === false
																	? 'has-error'
																	: '')
															}
														>
															<label className="col-md-4 control-label" htmlFor="tokenId">
																Token ID
															</label>
															<div className="col-md-8">
																<input
																	type="text"
																	id="tokenId"
																	name="paymentField"
																	placeholder="Citadel"
																	maxLength="6"
																	value={this.state.tokenId}
																	onChange={this.setTokenId}
																/>
																{this.state.form.tokenId.valid === false && (
																	<div className="validation-message text-danger">
																		{this.state.form.tokenId.message}
																	</div>
																)}
																{tokenIdHelp}
															</div>
														</div>
													</div>
												)}
												<div className="row">
													<div
														className={
															'form-group col-md-6 ' +
															(this.state.form.cardNo.valid === false ? 'has-error' : '')
														}
													>
														<label className="col-md-4 control-label" htmlFor="cardNo">
															Card No<span className="text-danger">*</span>
														</label>
														<div className="col-md-8">
															<input
																type="text"
																id="cardNo"
																name="paymentField"
																placeholder="Enter Card Number"
																maxLength="19"
																value={this.state.form.cardNo?.value ?? ''}
																onChange={this.clearTokenId}
																ref={this.setCardNoInputRef}
																disabled={
																	this.state.form.paymentType.value ===
																	'useExpeditedShipping'
																}
															/>
															{this.state.form.cardNo.valid === false && (
																<div className="validation-message text-danger">
																	{this.state.form.cardNo.message}
																</div>
															)}
														</div>
													</div>
													<div
														className={
															'form-group col-md-6 ' +
															(this.state.form.cardExpDate.valid === false
																? 'has-error'
																: '')
														}
													>
														<label className="col-md-4 control-label" htmlFor="cardExpDate">
															Exp. Date
															<FieldLevelHelp
																helpText='Format: two digit month / two digit year; e.g. "12/23"'
																linkText=""
															/>
															<span className="text-danger">*</span>
														</label>
														<div className="col-md-8">
															<input
																type="text"
																id="cardExpDate"
																name="paymentField"
																placeholder="MM/YY"
																value={this.state.form.cardExpDate.value ?? ''}
																onChange={this.setFormValue}
																data-fieldname="cardExpDate"
																disabled={
																	this.state.form.paymentType.value ===
																	'useExpeditedShipping'
																}
															/>
															{this.state.form.cardExpDate.valid === false && (
																<div className="validation-message text-danger">
																	{this.state.form.cardExpDate.message}
																</div>
															)}
														</div>
													</div>
												</div>
												<div className="row">
													<div
														className={
															'form-group col-md-6 ' +
															(this.state.form.cardCvv.valid === false ? 'has-error' : '')
														}
													>
														<label className="col-md-4 control-label" htmlFor="cvv">
															CVV Code<span className="text-danger">*</span>
														</label>
														<div className="col-md-8">
															<input
																type="text"
																id="cardCvv"
																name="paymentField"
																maxLength="4"
																placeholder="Enter Security Code"
																value={this.state.form.cardCvv.value ?? ''}
																onChange={this.setFormValue}
																data-fieldname="cardCvv"
																disabled={
																	this.state.form.paymentType.value ===
																	'useExpeditedShipping'
																}
															/>
															{this.state.form.cardCvv.valid === false && (
																<div className="validation-message text-danger">
																	{this.state.form.cardCvv.message}
																</div>
															)}
														</div>
													</div>
													<div
														className={
															'form-group col-md-6 ' +
															(this.state.form.cardholderName.valid === false
																? 'has-error'
																: '')
														}
													>
														<label
															className="col-md-4 control-label"
															htmlFor="cardholderName"
														>
															Cardholder Name
															<span className="text-danger">*</span>
														</label>
														<div className="col-md-8">
															<input
																type="text"
																id="cardholderName"
																name="paymentField"
																placeholder="As Displayed on Card"
																value={this.state.form.cardholderName.value ?? ''}
																onChange={this.setFormValue}
																data-fieldname="cardholderName"
																disabled={
																	this.state.form.paymentType.value ===
																	'useExpeditedShipping'
																}
															/>
															{this.state.form.cardholderName.valid === false && (
																<div className="validation-message text-danger">
																	{this.state.form.cardholderName.message}
																</div>
															)}
														</div>
													</div>
												</div>
												<div className="row">
													<div
														className={
															'form-group col-md-6 ' +
															(this.state.form.cardZipCode.valid === false
																? 'has-error'
																: '')
														}
													>
														<label
															className="col-md-4 control-label"
															htmlFor="billingZipCode"
														>
															{isUKOrder(this.props.gearOrder) ? 'Postal Code' : 'Billing Zip Code'}
															<span className="text-danger">*</span>
														</label>
														<div className="col-md-8">
															<input
																type="text"
																maxLength="8"
																id="cardZipCode"
																name="paymentField"
																placeholder={isUKOrder(this.props.gearOrder) ? 'Enter Postal Code' : 'Enter Billing Zip Code'}
																value={this.state.form.cardZipCode.value ?? ''}
																autoComplete="new-password"
																onChange={this.setFormValue}
																data-fieldname="cardZipCode"
																disabled={
																	this.state.form.paymentType.value ===
																	'useExpeditedShipping'
																}
															/>
															{this.state.form.cardZipCode.valid === false && (
																<div className="validation-message text-danger">
																	{this.state.form.cardZipCode.message}
																</div>
															)}
														</div>
													</div>
												</div>
												{(this.state.paymentPlanEligible) && (
													<div id="paymentPlans">
														<PaymentPlans
															totalPaymentAmount={this.state.totalPaymentAmount}
															fullPayAmounts={this.state.fullPayAmounts}
															paymentPlan={this.state.paymentPlan}
															paymentInstallments={this.state.paymentInstallments}
															setPaymentPlanValidity={(o) =>
																this.setPaymentPlanValidity(o)
															}
															setPaymentPlan={(o) => this.setPaymentPlan(o)}
															setPaymentInstallments={(o) =>
																this.setPaymentInstallments(o)
															}
															setPaymentInterval={(o) => this.setPaymentInterval(o)}
															setAuthAmounts={(o) => this.setAuthAmounts(o)}
														/>
													</div>
												)}
											</div>
										)}
										{(this.props.userInfo.type === 'prc' && !this.state.physicianInTheLoopOrder && !ukOrder) && (
											<>
												{/* TODO let user know if prepayment was made, and if additional payment is required... */}
												<div
													className={
														'radio ' +
														(this.state.form.paymentType.valid === false ? 'has-error' : '')
													}
												>
													<label htmlFor="prepayPayment">
														<input
															id="prepayPayment"
															name="paymentType"
															type="radio"
															value="prepay"
															onClick={this.togglePaymentType}
															defaultChecked={
																this.state.form.paymentType.value === 'prepay'
															}
														/>
														I prepaid for this test
													</label>
												</div>
												{this.state.form.paymentType.value === 'prepay' && (
													<div id="prepayInfoSection" className="well payment-details">
														<p className="text-default">
															<strong>
																Please enter your 6-digit confirmation code.
															</strong>
															<br />
														</p>
														<div
															className={
																'form-group ' +
																(this.state.form.prepay.valid === false
																	? 'has-error'
																	: '')
															}
														>
															<label
																className="col-md-2 control-label"
																htmlFor="prepayCode"
															>
																Confirmation Code
															</label>
															<div className="col-md-10">
																<input
																	type="text"
																	id="prepayCode"
																	name="paymentField"
																	placeholder="6-digit confirmation code"
																	value={this.state.form.prepay.value ?? ''}
																	ref={this.setPrepayInputRef}
																	onChange={this.setFormValue}
																	data-fieldname="prepay"
																/>
																{this.state.form.prepay.valid === false && (
																	<div className="validation-message text-danger">
																		{this.state.form.prepay.message}
																	</div>
																)}
															</div>
														</div>
													</div>
												)}
												{isResubmittalOrder && (
													<div className="radio">
														<label>
															<input
																type="radio"
																name="paymentType"
																id="resubmittalPayment"
																value="resubmittal"
																checked={this.state.form?.paymentType?.value === 'resubmittal'}
																onChange={this.togglePaymentType}
															/>
															Payment was provided with original order
														</label>
													</div>
												)}
											</>
										)}
									</div>
								</form>
							</div>
						)}
						{(this.state.form?.paymentType?.value === 'resubmittal') && (
							<ResubmittalPaymentAlert />
						)}
							{/* Acknowledgements */}
							{/* NSA Acknowledgement if not UK order and not PITL order */}
							{/* Patient Acknowledgement if not already acknowledged */}
							<div className="ps-3" hidden={!displayNSAAck && !displayPatientAck}>
								<div className="well">
									{/**************** NSA ***************/}

									{displayNSAAck &&
										(
											<div
												id="nsaAcknowledgmentSection"
												className="row"
												style={{ marginTop: 25 }}
												hidden={
													this.props.userInfo.type === 'myGDX' ||
													this.props.gearOrder.nsaAcknowledged ||
													this.state.configErrorFound
												}
											>
												<div><h4>No Surprises Act (NSA) Acknowledgement</h4></div>
												<div id="patient-ack-scroll">
													<div>
														{this.state?.nsaAcknowledgementError && (
															<div className="alert alert-danger" role="alert">
																<strong>{this.state.nsaAcknowledgementError}</strong>
															</div>
														)}
														{this.state.nsaAcknowledgement &&
															<small dangerouslySetInnerHTML={{ __html: this.state.nsaAcknowledgement }}></small>
														}
													</div>
													<div className="checkbox text-right space-top">
														<label
															className={
																'control-label ' +
																(this.state.form.patientNSAAcknowledged.valid === false ? 'has-error text-danger' : '')
															}
															htmlFor="patientNSAAcknowledged"
														>
															<input
																id="patientNSAAcknowledged"
																type="checkbox"
																name="paymentField"
																checked={this.state.form.patientNSAAcknowledged?.value}
																required={this.nsaAckRequired()}
																onChange={this.setFormValue}
																data-fieldname="patientNSAAcknowledged"
																disabled={!!this.state.nsaAcknowledgementError}
															/>
															<strong>
																I acknowledge that I have received and reviewed the No Surprises Act disclosure. I understand my rights and protections against surprise medical bills, and I authorize this acknowledgment as my electronic signature.
															</strong>
														</label>
														{this.state.form.patientNSAAcknowledged.valid === false && (
															<div className="text-danger validation-message pl-20">
																{this.state.form.patientNSAAcknowledged.message}
															</div>
														)}
													</div>
												</div>
											</div>
										)}

									{/****** Patient Acknowledgement *****/}
									<div
										id="acknowledgmentSection"
										className="row"
										style={{ marginTop: 25 }}
										hidden={!displayPatientAck}
									>
										<div>
											<h4>Patient/Responsible Party Acknowledgement</h4>
											<div id={(this.props.gearOrder.physicianInTheLoop || isUKOrder(this.props.gearOrder)) ? null : "patient-ack-scroll"}>
												{this.props.gearOrder.physicianInTheLoop
													? <PITLPatientAcknowledgement hasAffiliateCode={this.state.hasAffiliateCode} />
													: (<div>
														{!!this.state.patientAcknowledgementError && (
															<div className="alert alert-danger" role="alert">
																<strong>{this.state.patientAcknowledgementError}</strong>
															</div>
														)}
														{this.state.patientAcknowledgement &&
															<small dangerouslySetInnerHTML={{ __html: this.state.patientAcknowledgement }}></small>
														}
													</div>)
												}
												<div className={"checkbox" + (this.props.gearOrder.physicianInTheLoop ? "" : " text-right space-top")}>
													<label
														className={
															'control-label ' +
															(this.state.form.patientAgreement.valid === false ? 'has-error text-danger' : '')
														}
														htmlFor="patientAgreement"
													>
														<input
															id="patientAgreement"
															type="checkbox"
															name="paymentField"
															checked={this.state.form.patientAgreement?.value}
															required={patientAgreementRequired}
															onChange={this.setFormValue}
															data-fieldname="patientAgreement"
															disabled={!!this.state.patientAcknowledgementError}
														/>
														<strong>
															{this.props.gearOrder.physicianInTheLoop
																? <PITLPatientAcknowledgementCheckboxText hasAffiliateCode={this.state.hasAffiliateCode} />
																: 'I have read and agree to the terms above as the Patient/Responsible Party.'
															}
														</strong>
													</label>
													{this.state.form.patientAgreement.valid === false && (
														<div className="text-danger validation-message pl-20">
															{this.state.form.patientAgreement.message}
														</div>
													)}
												</div>
											</div>
										</div>
									</div>
								</div>							
							</div>
						{!hidePaymentSection && (
							<>
								{this.isShowRecaptcha() && (
									<>
										<ReCAPTCHA
											grecaptcha={this.state.grecaptchaObject}
											sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITEKEY}
											onChange={this.setCaptchaValue}
											style={{ display: 'inline-block', outline: this.state.form.captcha?.valid === false ? '1px solid red' : '' }}
											scriptcount={this.state.recaptchaScriptCount}
										/>
										{this.state.form.captcha?.valid === false && (
											<div className="validation-message text-danger">
												{this.state.form.captcha.message}
											</div>
										)}	
									</>
								)}
								<div className="space-top"></div>
								<RequiredFieldDisclaimer />
							</>
						)}
					</>
				)}
			</PanelWrapper>
			</>
		);
	};

	render() {
		return (
			// SCR-8729
			// <PayPalScriptProvider
			// 	options={{
			// 		'client-id': process.env.REACT_APP_PAYPAL_CLIENT_ID,
			// 		'disable-funding': 'card,paylater',
			// 		components: 'buttons,marks,funding-eligibility'
			// 	}}
			// >
				<div className="row">
					<div className="col-md-12">
						<PanelWrapper condition={this.isShowExpeditedShippingPayment()}>
							<ExpeditedShippingPayment
								userInfo={this.props.userInfo}
								gearOrder={this.props.gearOrder}
								handlePaymentInputChange={this.handleExpeditedPaymentInputChange}
								onSubmit={this.handleSubmit}
								paymentDetails={this.state.expeditedShippingPaymentDetails}
								onShippingEdit={this.editShippingMethod}
							/>
						</PanelWrapper>

						{this.buildTestChargesDisplay()}
					</div>
					{this.state.showUpdatedPaymentRequired && (
						<UpdatedPaymentRequired
							modalHidden={() => this.setState({ showUpdatedPaymentRequired: false })}
							gearOrder={this.props.gearOrder}
						/>
					)}
				</div>
			// </PayPalScriptProvider>
		);
	}
}

/**
 * A component that wraps children elements in a panel div based on a condition.
 * If the condition is true, the children will be returned inside the panel div.
 * If the condition is false, the children will be returned unaltered.
 *
 * @param condition A boolean indicating if the children should be wrapped in a panel div
 * @param children The child elements to display
 */
 const PanelWrapper = ({ condition, children }) => {
	return condition ? (
		<div className="panel panel-default">
			<div className="panel-body">{children}</div>
		</div>
	) : (
		children
	);
};

const ResubmittalPaymentAlert = () => {
	return (
		<AlertMessage type="info">
			<div>
				If you provided the full initial payment with your original specimen submission, you do not need to
				submit an additional payment. We will bill the recollection using the same billing method as the
				original specimen submission, but we may place your recollected specimens on a separate order to prevent
				reporting delays. If we are billing your insurance, please be aware that you may owe additional amounts
				after your insurance processes your claim. The amount due for your original and resubmitted specimens
				will not exceed the out of pocket cost displayed above, so long as you paid your full initial payment
				and respond promptly to any bills you may receive in the future.
			</div>
		</AlertMessage>
	);
}

/**
 * Shows a Payment Successful message when we have a PayPal order ID. Shows the PayPal buttons 
 * when we don't have an order ID yet.
 */
// const PaypalButtonContainer = (props) => {
// 	if (props.paypalOrderId) {
// 		return (
// 			<>
// 				<i className="fa fa-check-circle pull-left text-success mt-10" aria-hidden="true" style={{ fontSize: '1.5em' }}></i>
// 				<PayPalMarks fundingSource={props.fundingSource} />
// 				<p style={{marginLeft: '46px'}}>Please submit your order below</p>
// 			</>
// 		);
// 	}

// 	return (
// 		<>
// 			<h4 className="mb-20" style={{ marginLeft: '-20px' }}>
// 				Please select your payment method
// 			</h4>
// 			<PayPalButtonWrapper style={{ maxWidth: '200px' }}>
// 				{props.children}
// 				<div className="hr-text ">
// 					<hr />
// 					<span>or</span>
// 				</div>
// 			</PayPalButtonWrapper>
// 		</>
// 	);
// };


export default withWorkflow(PaymentInfo);
